import router from '../../router.js';
export const toGateway = () => {
  const gateway_path = localStorage.getItem('_gateway_path')
  const gateway_data = localStorage.getItem('_gateway_data');
  if (!gateway_path) {
    return false;
  }
  localStorage.removeItem('_gateway_path');
  localStorage.removeItem('_gateway_data');
  const isUrl = /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/.test(gateway_path);
  if (isUrl) {
    // 123
    const [origin, query] = gateway_path.split('?')
    const usp = new URLSearchParams(query)
    usp.append('data', gateway_data || '');
    location.href = origin + '?' + usp.toString();
  } else {
    router.push({
      path: gateway_path,
      query: {
        data: gateway_data,
      }
    });
  }
  return true;
}